import { CookieSettingsLink } from '@/components/cookieSettingsLink';
import { InvestorDeclarationEventHandler } from '@/components/InvestorDeclarationEventHandler';
import { MetaEventHandler } from '@/components/MetaEventHandler';
import { PostHogEventHandler } from '@/components/PostHogEventHandler';
import { WakalaFlagRelay } from '@/features/wakala/components/wakalaFlagRelay';
import { WaqfFlagRelay } from '@/features/waqf/components/waqfFlagRelay';
import { GrowthbookProvider } from '@/libs/growthbook';
import { postHogConsentOptions } from '@/libs/postHogConsent';
import { isTenant } from '@repo/utils';
import { PostHogConfig } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { PropsWithChildren } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { TanstackQueryProvider } from '../libs/tanstackQuery';

const postHogOptions: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-05-24',
  // Pfida: nothing captured or stored until an analytics yes in the cookie banner
  ...(isTenant('pfida') ? postHogConsentOptions() : {}),
};

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={postHogOptions}>
      <PostHogEventHandler />
      <MetaEventHandler />
      <InvestorDeclarationEventHandler />
      {isTenant('pfida') && <CookieSettingsLink />}
      <HelmetProvider>
        <GrowthbookProvider>
          <WakalaFlagRelay />
          <WaqfFlagRelay />
          <TanstackQueryProvider>{children}</TanstackQueryProvider>
        </GrowthbookProvider>
      </HelmetProvider>
    </PostHogProvider>
  );
}
